import Splide from '@splidejs/splide';
import {Video} from '@splidejs/splide-extension-video';
import lightGallery from 'lightgallery/lightgallery.umd';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import JSZip from 'jszip';

document.addEventListener('DOMContentLoaded', () => {

        const singleProductPage = document.querySelector('.single-product')

        if (singleProductPage !== null) {

            document.querySelectorAll('select[name="quantity"]').forEach(quantityInput => {

                quantityInput.addEventListener('change', () => {
                    const submitButton = document.querySelector('.js-product-multiple-submit')
                    const id = quantityInput.closest('.js-input-container').dataset.id
                    const value = quantityInput.value
                    const hiddenInput = document.querySelector('input[name="quantity[' + id + ']"]')

                    submitButton.classList.add('disabled')

                    if (hiddenInput) {
                        hiddenInput.value = value;
                    }

                    document.querySelectorAll('.js-product-multiple-input-hidden').forEach(input => {

                        if (input.value > 0) {
                            submitButton.classList.remove('disabled')
                        }
                    })

                });

            });

            // light gallery product images
            const productGallery = lightGallery(document.querySelector('.c-product-gallery-popup'), {
                licenseKey: '27B98EF2-267A-4491-A872-77C77982E925',
                plugins: [lgZoom, lgVideo],
                download: false
            });

            document.querySelectorAll('.splide-main__single').forEach(function (slide) {
                slide.addEventListener('click', function () {
                    if (!this.getAttribute('data-splide-youtube')) {
                        const slideId = this.getAttribute('data-id');
                        const newSlideId = slideId - 1;
                        productGallery.openGallery(newSlideId);
                    }
                });
            });

            /** Setup sliders */
            const mainSliderClass = '.splide-main.splide'

            const slider = new Splide(mainSliderClass, {
                fixedWidth: '100%',
                fixedHeight: '68.7rem',
                rewind: true,
                pagination: false,
                arrows: true,
                breakpoints: {
                    1024: {
                        fixedHeight: '35.3rem',
                    },
                },
            })

            const thumbnails = new Splide('.splide-thumbnails', {
                fixedWidth: 'calc((100% / 3) - 1rem)',
                fixedHeight: '20rem',
                gap: '2rem',
                rewind: true,
                pagination: false,
                arrows: false,
                isNavigation: true,
                breakpoints: {
                    1024: {
                        fixedWidth: '10rem',
                        fixedHeight: '8rem',
                        gap: '1rem',
                    },
                },

            })

            slider.sync(thumbnails)
            slider.mount({Video})
            thumbnails.mount();

            /** Simple product minus button logic */
            const minusButtons = document.querySelectorAll(".js-input-container .minus");

            if (minusButtons.length) {
                minusButtons.forEach(minusButton => {
                    minusButton.addEventListener('click', function () {
                        const id = this.getAttribute("data-id")
                        changeQuantityInput(id, -1)
                    });
                })
            }

            /** Simple product plus button logic */


            const plusButtons = document.querySelectorAll(".js-input-container .plus");

            if (plusButtons.length) {
                plusButtons.forEach(plusButton => {
                    plusButton.addEventListener('click', function () {
                        const id = this.getAttribute("data-id")
                        changeQuantityInput(id, +1)
                    });
                })
            }

            /** Simple product change quantity */

            const changeQuantityInput = (id, direction) => {

                const input = document.querySelector('.js-input-container[data-id="' + id + '"] input')
                let newValue = parseFloat(input.value + '') + parseFloat(direction)

                if (newValue >= 0) {
                    input.value = newValue
                }
            }

            /** Color collapse button */

            const productCollapseButton = document.querySelector('.js-product-collapse-button')

            if (typeof productCollapseButton !== 'undefined') {
                productCollapseButton?.addEventListener('click', function () {
                    document.querySelector('.c-product-collection__colours').classList.add('is-collapsed')
                })
            }

            /** Color slider */
            document.querySelectorAll('.c-product-collection__colours__item').forEach(function (color) {
                color.addEventListener('click', function (e) {
                    e.preventDefault();

                    const parentSelector = '.c-product-collection'
                    const selectedImageUrl = this.dataset.imageurl
                    const selectedColourCode = this.dataset.cc
                    const selectedUrl = this.dataset.url
                    const selectedSrcSet = this.dataset.srcset
                    const productTitle = this.dataset.producttitle

                    const parentImage = document.querySelector(parentSelector + ' img')
                    const currentColors = document.querySelectorAll('.c-product-collection__colours__item.is-current')
                    const collectionButton = document.querySelector('.js-collection-button')

                    if (selectedUrl) {
                        collectionButton.style.display = 'block'
                        collectionButton.href = selectedUrl
                    }

                    if (!selectedUrl) {
                        collectionButton.style.display = 'none'
                    }

                    document.querySelector('.c-product-collection__current h4 strong').innerHTML = selectedColourCode

                    let elementStrong = document.querySelector('.c-product-collection__current h4 strong');
                    if (elementStrong) {
                        elementStrong.innerHTML = selectedColourCode;
                    }

                    let elementProductTitle = document.querySelector('.c-product-collection__current h4 .product-title');
                    if (elementProductTitle) {
                        elementProductTitle.innerHTML = productTitle;
                    }

                    parentImage.src = selectedImageUrl

                    if (selectedSrcSet) {
                        parentImage.srcset = selectedSrcSet
                    }

                    currentColors?.forEach(function (currentColor) {
                        currentColor.classList.remove('is-current')
                    })

                    this.classList.add('is-current')

                })
            })


            document.querySelectorAll('.js-modal-btn').forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    const modalScreen = document.querySelector('.js-image-modal')
                    const documentBody = document.body

                    if (modalScreen.classList.contains('open')) {
                        modalScreen.classList.remove('open')
                        documentBody.classList.remove('no-scroll')
                        return
                    }

                    if (!modalScreen.classList.contains('open')) {
                        modalScreen.classList.add('open')
                        documentBody.classList.add('no-scroll')
                    }
                })
            })


            const selectAll = document.querySelector('.js-modal-select-all')
            selectAll.addEventListener('click', function () {
                document.querySelectorAll('.js-modal-item-select').forEach(function (checkbox) {
                    selectAll.checked === true ? checkbox.checked = true : checkbox.checked = false
                })
                document.querySelector('.js-download-selection').disabled = !selectAll.checked

            })

            const fileSelects = document.querySelectorAll('.js-modal-item-select')

            const totalFiles = fileSelects.length
            let selectedFilesCount = 0

            fileSelects.forEach(function (checkbox) {

                if (checkbox.checked === true) {
                    selectedFilesCount++
                }

                checkbox.addEventListener('change', function () {
                    checkbox.checked === true ? selectedFilesCount++ : selectedFilesCount--
                    selectedFilesCount === totalFiles ? selectAll.checked = true : selectAll.checked = false

                    document.querySelector('.js-download-selection').disabled = selectedFilesCount === 0

                })
            })


            document.querySelectorAll('.js-request-product-quantity').forEach(requestInputDiv => {

                const id = requestInputDiv.attributes['data-id'].value

                requestInputDiv.querySelector('select[name="quantity"]').addEventListener('change', (e) => {

                    const value = e.target.value

                    document.querySelectorAll('.js-product-on-request-modal-btn').forEach(function (btn) {

                        if (btn.attributes['data-id'] && btn.attributes['data-id'].value === id) {
                            btn.attributes['data-quantity'].value = value
                        }
                    })

                });

            });

            document.querySelectorAll('.js-product-on-request-modal-btn').forEach(function (btn) {

                btn.addEventListener('click', function () {

                    const productInfo = {
                        image: btn && btn.attributes['data-image'] ? btn.attributes['data-image'].value : '',
                        label: btn && btn.attributes['data-label'] ? btn.attributes['data-label'].value : '',
                        sku: btn && btn.attributes['data-sku'] ? btn.attributes['data-sku'].value : '',
                        title: btn && btn.attributes['data-title'] ? btn.attributes['data-title'].value : '',
                        quantity: btn && btn.attributes['data-quantity'] ? btn.attributes['data-quantity'].value : ''
                    }

                    toggleProductOnRequestModal(productInfo)
                })
            })

            function toggleProductOnRequestModal(productInfo) {
                const modalScreen = document.querySelector('.js-product-on-request-modal')
                const documentBody = document.body

                document.querySelector('.js-product-image').src = productInfo.image
                document.querySelector('.js-product-label').innerHTML = productInfo.label
                document.querySelector('.js-product-sku').innerHTML = '#' + productInfo.sku
                document.querySelector('.js-product-title').innerHTML = productInfo.title

                if (!productInfo.quantity || productInfo.quantity === '0') {
                    document.querySelector('.js-product-quantity').innerHTML = 1
                } else {
                    document.querySelector('.js-product-quantity').innerHTML = productInfo.quantity
                }

                if (document.getElementById('input_25_3') && document.getElementById('input_25_4')) {
                    document.getElementById('input_25_3').value = productInfo.label + ' - #' + productInfo.sku + ' | ' + productInfo.title

                    if (!productInfo.quantity || productInfo.quantity === '0') {
                        document.getElementById('input_25_4').value = 1
                    } else {
                        document.getElementById('input_25_4').value = productInfo.quantity
                    }
                }

                if (modalScreen.classList.contains('open')) {
                    modalScreen.classList.remove('open')
                    documentBody.classList.remove('no-scroll')

                    return
                }

                if (!modalScreen.classList.contains('open')) {
                    modalScreen.classList.add('open')
                    documentBody.classList.add('no-scroll')
                }
            }
        }
    }
)

document.addEventListener('DOMContentLoaded', function () {
    const modalElement = document.querySelector('.js-image-modal');

    if (!modalElement) return;

    const cdnUrl = modalElement.dataset.cdnUrl;
    const originalUrl = modalElement.dataset.originalUrl;

    if (!cdnUrl || !originalUrl) return;

    const links = document.querySelectorAll('.c-modal-row__item__body a');
    links?.forEach(function (link) {
        link.href = link.href.replace(cdnUrl, originalUrl);
    });

    const hiddenInputs = document.querySelectorAll('input[type="hidden"][name="all-files[]"], .js-modal-item-select');
    hiddenInputs?.forEach(function (input) {
        input.value = input.value.replace(cdnUrl, originalUrl);
    });
})

document.addEventListener('DOMContentLoaded', function () {
    const modalElement = document.querySelector('.c-product-gallery-popup');

    if (!modalElement) return;

    const cdnUrl = modalElement.dataset.cdnUrl;
    const originalUrl = modalElement.dataset.originalUrl;

    if (!cdnUrl || !originalUrl) return;

    const links = modalElement.querySelectorAll('[data-download-url]');

    links.forEach(function (element) {
        const originalDownloadUrl = element.dataset.downloadUrl;
        element.dataset.downloadUrl = originalDownloadUrl.replace(cdnUrl, originalUrl);
    });
})


document.querySelectorAll('select[name="quantity"]').forEach(quantityInput => {
    const form = quantityInput.closest('.c-product-simple-products__table__row__cart');
    const submitButton = form.querySelector('button[type="submit"]');
    const emailButton = form.querySelector('.js-product-on-request-modal-btn');

    submitButton?.classList.add('disabled');

    quantityInput.addEventListener('change', () => {
        if (quantityInput.value > 0) {
            submitButton?.classList.remove('disabled');
            emailButton?.classList.remove('disabled');
        }

        if (quantityInput.value <= 0) {
            submitButton?.classList.add('disabled');
            emailButton?.classList.add('disabled');
        }
    });
});


jQuery(document).ready(function ($) {
    var productId = $('#product-id').val(); // Assuming you have a hidden input with the product ID
    var container = $('#product-simple-products-container'); // The container where the HTML will be updated
    var loader = $('#loader'); // The loader element

    if (productId === undefined || container === undefined) {
        return;
    }

    // Show the loader
    loader.show();

    $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
            action: 'get_product_simple_products_html',
            product_id: productId
        },
        success: function (response) {
            // Hide the loader
            loader.hide();

            if (response.success) {
                container.html(response.data.html);


                document.querySelectorAll('select[name="quantity"]').forEach(quantityInput => {
                    const form = quantityInput.closest('.c-product-simple-products__table__row__cart');
                    const submitButton = form.querySelector('button[type="submit"]');
                    const emailButton = form.querySelector('.js-product-on-request-modal-btn');

                    submitButton?.classList.add('disabled');

                    quantityInput.addEventListener('change', () => {
                        if (quantityInput.value > 0) {
                            submitButton?.classList.remove('disabled');
                            emailButton?.classList.remove('disabled');
                        }

                        if (quantityInput.value <= 0) {
                            submitButton?.classList.add('disabled');
                            emailButton?.classList.add('disabled');
                        }
                    });
                });

                document.querySelectorAll('select[name="quantity"]').forEach(quantityInput => {

                    quantityInput.addEventListener('change', () => {
                        const submitButton = document.querySelector('.js-product-multiple-submit')
                        const id = quantityInput.closest('.js-input-container').dataset.id
                        const value = quantityInput.value
                        const hiddenInput = document.querySelector('input[name="quantity[' + id + ']"]')

                        submitButton.classList.add('disabled')

                        if (hiddenInput) {
                            hiddenInput.value = value;
                        }

                        document.querySelectorAll('.js-product-multiple-input-hidden').forEach(input => {

                            if (input.value > 0) {
                                submitButton.classList.remove('disabled')
                            }
                        })

                    });

                });

            } else {
                container.html('<p>Error fetching product details</p>');
            }
        },
        error: function () {
            // Hide the loader
            loader.hide();
            container.html('<p>Error fetching product details</p>');
        }
    });
});

